export default (o, c, d) => {
  c.prototype.isWeekend = function () {
    return this.day() === 0 || this.day() === 6 /* 0 för söndag, 6 för lördag */
  }
}
